function NoDataError(message) {
  this.name = 'NoDataError';
  this.message = message || 'Default Message';
  this.stack = new Error().stack;
}
NoDataError.prototype = Object.create(Error.prototype);
NoDataError.prototype.constructor = NoDataError;

export default NoDataError;
